import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { moats, Moat, interpretations } from './moats';
import Rating from './Rating';

function App() {
  const [scores, setScores] = useState<number[]>(Array(moats.length).fill(0));
  const [averageScore, setAverageScore] = useState<number | null>(null);
  const [interpretation, setInterpretation] = useState<string>("");

  const handleRate = (index: number, score: number) => {
    const newScores = [...scores];
    newScores[index] = score;
    setScores(newScores);
  };

  const handleCalculate = () => {
    if (scores.some(score => score === 0)) {
      alert("請完成所有項目的評分！");
      return;
    }

    const total = scores.reduce((sum, score) => sum + score, 0);
    const avg = total / moats.length;
    setAverageScore(avg);

    let resultInterpretation = "";
    if (avg >= 4.0) {
      resultInterpretation = interpretations["4.0-5.0"];
    } else if (avg >= 3.0) {
      resultInterpretation = interpretations["3.0-3.9"];
    } else if (avg >= 2.0) {
      resultInterpretation = interpretations["2.0-2.9"];
    } else {
      resultInterpretation = interpretations["0.0-1.9"];
    }
    setInterpretation(resultInterpretation);
  };

  return (
    <div className="container mt-5">
      <header className="text-center mb-5">
        <h1>🧭 個體護城河評估表</h1>
        <p className="lead">Personal Moat Assessment Sheet</p>
      </header>

      <details className="card mb-4">
        <summary className="card-header fw-bold">關於此評估表 (點此展開)</summary>
        <div className="card-body">
          <p>這個評估表的靈感，源自知名創投 Y Combinator 的一集 Podcast，他們探討了商業策略大師 Hamilton Helmer 在其著作《7 Powers》中提到的「護城河」概念。</p>
          <p>然而，商業世界的宏大戰略，是否也能應用於個人的職涯發展？這份評估表，就是一次大膽的嘗試。我們將「企業護城河」的概念，從公司層級轉譯到「個體層級」，特別是針對這個時代的自由職業者、創作者與獨立創業者。</p>
          <p>我們相信，每個人都值得擁有一條屬於自己的、深邃的護城河。透過這七個維度的自我評估，您將能更清晰地看見自己的核心競爭力、發現可以強化的優勢，並找到建立長期價值與個人品牌的獨特路徑。這不是一次考試，而是一次深入的自我對話。</p>
          <a href="https://www.ycombinator.com/library/Mx-the-7-most-powerful-moats-for-ai-startup" target="_blank" rel="noopener noreferrer">原始討論請參考：Y Combinator Podcast</a>
        </div>
      </details>

      <div className="assessment-form">
        {moats.map((moat, index) => (
          <div key={index} className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">
                <span className="me-2">{moat.icon}</span>
                {moat.name}
                <small className="text-muted ms-2">{moat.englishName}</small>
              </h5>
            </div>
            <div className="card-body">
              <p className="card-text">{moat.question}</p>
              <Rating score={scores[index]} onRate={(score) => handleRate(index, score)} />
            </div>
          </div>
        ))}
      </div>

      {averageScore !== null && (
        <div className="results text-center mt-5 p-4 bg-light rounded">
          <h2>評估結果</h2>
          <h3>平均分: {averageScore.toFixed(2)}</h3>
          <p className="lead mt-3">{interpretation}</p>
        </div>
      )}

      <footer className="text-center mt-5 mb-5">
        <button className="btn btn-primary btn-lg" onClick={handleCalculate}>
          計算結果
        </button>
      </footer>
    </div>
  );
}

export default App;
